<template>
  <div class="main-page-app">
    <DeveloperInfo />
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
import DeveloperInfo from "@/components/developerInfo/index.vue";

export default {
  components: {
    DeveloperInfo,
  },

  computed: {
    key() {
      return this.$router.name !== undefined
        ? this.$router.name + +new Date()
        : this.$router + +new Date();
    },
  },
};
</script>
<style scoped>
.main-page-app {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// App.vue?0b544542